import { compose, join, view, lensPath, pluck } from 'ramda';
export const getRedirectPath = compose(
  join('/'),
  pluck('path'),
  view(lensPath(['_urlSegment', 'segments']))
);
